import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { qrLogotype } from "../../../../../redux/slices/qrSettings";
import FileUpload from "../../../../../components/input/fileUpload";
import Form from "react-bootstrap/Form";
import { registerPlugin } from "react-filepond";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

registerPlugin(FilePondPluginFileValidateSize, FilePondPluginFileValidateType);

function LogotypeAddBtn({ setLogoShow }) {
  const lang = useSelector((state) => state.changeLang.language.stepThree.logo);
  const logotype = useSelector((state) => state.qrSettings.logotype);

  const [file, setFile] = useState([]);
  const dispatch = useDispatch();
  const [logo, setLogo] = useState(logotype);
  const [sizeLimit, setSizeLimit] = useState(false);
  useEffect(() => {
    if (logotype?.toString()?.includes("/qr/logo/")) {
      setLogoShow(logotype);
    }
  }, [logotype]);
  useEffect(() => {
    dispatch(qrLogotype(logo));
  }, [logo]);

  function handleChangeLogo(file) {
    if (file.size <= 2000000) {
      setSizeLimit(false);
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setLogo(reader.result);
        setLogoShow(reader.result);
      };
    } else {
      setSizeLimit(true);
      setTimeout(() => {
        setSizeLimit(false);
      }, 5000);
    }
  }

  useEffect(() => {
    if (file[0]?.file) {
      handleChangeLogo(file[0]?.file);
    }
  }, [file]);

  return (
    <>
      <FileUpload
        className="mb-1"
        files={file}
        onupdatefiles={(file) => {
          setFile(file);
        }}
        allowFileSizeValidation={true}
        allowFileTypeValidation={true}
        maxFileSize={"2MB"}
        allowMultiple={false}
        maxFiles={1}
        name="image"
        acceptedFileTypes={["image/jpeg", "image/png", "image/svg+xml"]}
        label={lang[3]}
        popoverText={null}
        colorPink={true}
      />
      {sizeLimit && (
        <Form.Text className="text-danger">max logo size 2 mb</Form.Text>
      )}
      <div className="fs-7 text-gray mb-3 mt-1">{lang[4]}</div>
    </>
  );
}

export default LogotypeAddBtn;
